import Cookies from "universal-cookie";
import { getSelectedConsolidatedMids, isConsolidatedDashboard, isTestMode } from "dashboard-utils";
import { AUTH_TOKEN, MERCHANT_MID, PRODUCT, TEST_AUTH_TOKEN, TEST_MERCHANT_MID } from "../../constants/cookieKeys";
import { endPoints, appUrls } from "../../constants/urls";
import { isVistaApplication } from "../../utils/vistaApp";
import ls from "local-storage";

export function setupAxios(axios) {
  axios.interceptors.request.use(
    (config) => {
      const cookies = new Cookies();
      const authToken = cookies.get(AUTH_TOKEN),
        merchantMID = cookies.get(MERCHANT_MID),
        product = cookies.get(PRODUCT),
        testAuthToken = cookies.get(TEST_AUTH_TOKEN),
        testMerchantMID = cookies.get(TEST_MERCHANT_MID);

      /**
       * set authToken, Mid & Product from cookies in headers
       * if any of the three (authToken, MID & Product) is not present in cookies or either cookies are expired
       * then requested API will send unauthenticated response or any other server error
       * which is handled in axios response interceptors
       */
      config.headers.Authorization = isTestMode ? `Bearer ${testAuthToken}` : `Bearer ${authToken}`;
      config.headers.Mid = isTestMode ? `${testMerchantMID}` : `${merchantMID}`;
      config.headers.Product = `${product}`;
      config.headers.Accept = "application/json";
      if(isConsolidatedDashboard) {
        config.headers.Mids = getSelectedConsolidatedMids().join(',');
      }

      return config;
    },
    (err) => Promise.reject(err)
  );

  axios.interceptors.response.use(
    (response) => {
      /**
       * Any status code that lie within the range of 2xx cause this function to trigger
       * Do something with response data if needed
       */
      return response;
    },
    (error) => {
      /**
       * Any status codes that falls outside the range of 2xx cause this function to trigger
       * Do something with response error
       */

      // The request was made and the server responded with a status code out of 2xx
      if (error.response) {
        // for unauthorized response, redirect on OnBoarding
        if (error.response.status === 401) {
          ls.remove('currentSession');
          ls.remove("consolidated_product_accounts");
          const ONBOARDING_HOST = process.env.ONBOARDING_HOST,
            DASHBOARD_HOST = isVistaApplication()
              ? appUrls.VISTA_DASHBOARD_HOST
              : process.env.DASHBOARD_HOST;
          const redirectionURL = `${ONBOARDING_HOST}${endPoints.CO_LOGIN_REDIRECT}${DASHBOARD_HOST}`;
          window.location.replace(redirectionURL);
        }
        // handle Internal Server Error
        if (error.response.status === 500) {
          error.message = "Some error occurred, please try again later";
        }
      }
      return Promise.reject(error);
    }
  );
}
